import { Link, notDesktop, styled, useContextPath, useRouter } from '@obvio/app'
import {
  CategoryInfoView,
  AgeRestrictionModal,
  useUi,
} from '@obvio/template'
import { Grid, Stack } from '@obvio/ui'
import { useEffect } from 'react'

import { CategoryNav } from './CategoryNav'
import { CategoryProducts } from './CategoryProducts'

import type {
  CATEGORIES_DATA,
  CATEGORY_DATA,
} from '@/pages/sklep/kategoria/[slug]'
import type { ReactElement } from 'react'

const WrapGrid = styled(Grid)`
  @media ${notDesktop} {
    grid-template-columns: 1fr;
  }
`

const PageWrap = styled(Stack)`
  margin-top: ${(theme) => theme.spacing.medium};
  padding: ${(theme) => `${theme.spacing.small} ${theme.spacing.medium}`};
`

const ListTitle = styled.span`
  letter-spacing: 0.175rem;
  font-size: 0.8125rem;
  margin-bottom: ${(theme) => theme.spacing.small};
  display: block;
`

type CategoryLayoutProps = {
  category?: Omit<CATEGORY_DATA, 'products'>
  products: CATEGORY_DATA['products']
  categories: CATEGORIES_DATA[]
}

export function CategoryLayout({
  category,
  categories,
  products,
}: CategoryLayoutProps): ReactElement {
  const { asPath } = useRouter()
  const [, dispatch] = useUi()
  const ecomCategoryPath = useContextPath('ecommerce.category')

  useEffect(() => {
    dispatch('CLOSE_ALL_PANELS')
  }, [dispatch, asPath])

  return (
    <PageWrap kind="vertical" spacing="large">
      <CategoryNav
        productsCount={products.length}
        title={category?.title ?? ''}
      />
      <WrapGrid templateColumns="20rem minmax(0,1fr)" gap="large">
        <Stack kind="vertical" spacing="extraLarge">
          {category ? (
            <CategoryInfoView
              category={category.title}
              description={category.description}
              slug={category.slug}
            />
          ) : null}
          <div>
            <ListTitle>KATEGORIA</ListTitle>
            <Stack kind="vertical" spacing="extraSmall">
              {categories.map((categoryData) => (
                <Link
                  href={`${ecomCategoryPath}/${categoryData.slug}`}
                  key={categoryData.id}
                >
                  {categoryData.title}
                </Link>
              ))}
            </Stack>
          </div>
        </Stack>
        <CategoryProducts products={products} />
        <AgeRestrictionModal age={category?.ageRestriction} />
      </WrapGrid>
    </PageWrap>
  )
}
